import { useMemo } from 'react'

const resolvePath = (data, pathString) => {
  const path = pathString?.split('.') ?? []
  if (path?.[0] === 'none') {
    return null
  }
  let value = data
  for (const p of path) {
    if (value && typeof value === 'object' && p in value) {
      value = value[p]
    } else {
      value = undefined
      break
    }
  }
  return value ?? undefined
}

export const useGetNodeValues = (nodeData, linkedEntityData) => {
  return useMemo(() => {
    const data = { ...nodeData ?? {} }
    if (data.entityProps) {
      const matchingLinkedEntityData = linkedEntityData?.[data.entityProps.levelTypeId]?.[data.entityProps.levelId]
      data.entityProps = {
        ...matchingLinkedEntityData,
        ...Object.keys(data?.entityProps ?? {}).reduce((acc, key) => {
          if (data.entityProps[key] !== undefined) {
            acc[key] = data.entityProps[key]
          }
          return acc
        }, {})
      }
    }

    const defaultDisplayOptions = {
      header: 'header',
      description: 'description',
      image: 'none',
      backgroundColor: 'style.backgroundColor',
      textColor: 'style.textColor',
      borderColor: 'style.borderColor'
    }

    const defaultEntityDisplayOptions = {
      header: 'entityProps.label',
      description: 'entityProps.description',
      image: 'none',
      backgroundColor: 'entityProps.color',
      textColor: 'style.textColor',
      borderColor: 'entityProps.color'
    }

    const displayOptions = {
      ...(data.entityProps ? defaultEntityDisplayOptions : defaultDisplayOptions),
      ...data?.displayOptions ?? {}
    }

    return Object.keys(displayOptions).reduce((acc, key) => {
      const value = resolvePath(data, displayOptions[key])
      if (value === undefined) {
        const defaultValue = resolvePath(data, defaultDisplayOptions[key])
        acc[key] = defaultValue || null
        return acc
      }
      acc[key] = value || null
      return acc
    }, {})
  }, [nodeData, linkedEntityData])
}
